<template>
	<div class="question-list">
		<div class="qna">
			<div class="qna-row" v-for="(item, index) in listData" :key="index" @click="handleQuestionDetail(item)">
				<div class="question-row">
					<div :class="['question-content', isDetails ? 'text-overflow3' : 'text-overflow']">
						<SvgIcons name="Qicon" class="question-label" />{{ item.question }}
					</div>
				</div>
				<div class="answer-row">
					<div :class="['answer-content', isDetails ? 'text-overflow3' : 'text-overflow2']">
						{{ $t('enterprise.answer') }}：{{ item.answer }}
					</div>
				</div>
				<div class="bottom-row" v-if="isDetails">
					<span class="question-type">{{ getSourceBizText(item) }}</span>
					<span class="question-date">{{ item.questionTime || '' }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import SvgIcons from '@/components/SvgIcons.vue';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useQuestionDisplayUtils } from '@rebuild/materials/shared/question/composables/useQuestionDisplayUtils';

defineProps({
	isDetails: {
		type: Boolean,
		default: false
	},
	listData: {
		type: Array,
		default: () => []
	}
});

const { getSourceBizText } = useQuestionDisplayUtils();

const { viewModule } = useModuleNavigation();
const handleQuestionDetail = item => {
	viewModule('question', item);
};
</script>

<style lang="less" scoped>
.qna {
	&-row {
		padding: 16px 0;
		border-bottom: 1px solid var(--border-lighter-color, #f2f3f5);

		.question-row {
			.question-content {
				color: var(--t-emphasis-color, #1d2129);

				font-size: 16px;

				font-weight: 500;
				line-height: 24px; /* 150% */

				.question-label {
					display: inline-flex;
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}
			}
		}
		.answer-row {
			margin-top: 10px;
			.answer-content {
				color: var(--t-secondary-color, #4e5969);

				font-size: 16px;

				font-weight: 400;
				line-height: 24px; /* 150% */
			}
		}
		.bottom-row {
			display: flex;
			justify-content: space-between;
			margin-top: 10px;
			.question-type {
				color: var(--t-secondary-color, #4e5969);

				font-size: 10px;
				line-height: 18px; /* 140% */
				padding: 0 4px;
				background: var(--fill-normal-color, #f2f3f5);
			}
			.question-date {
				color: var(--t-secondary-info-color, #86909c);
				text-align: right;

				font-size: 13px;
			}
		}
	}
	&-row:first-child {
		padding-top: 0;
	}
	&-row:last-child {
		padding-bottom: 0;
		border-bottom: none;
	}
}
</style>
